export default [{
	prop: 'billNo',
	label: '订单单号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'busDate',
	label: '业务日期',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'billState',
	label: '单据状态',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'restaurantName',
	label: '付款方企业',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'payName',
	label: '付款方机构',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentType',
	label: '付款方式',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'apMoney',
	label: '应付金额',
	width: '120',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'payMoney',
	label: '实付金额',
	width: '120',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'discountMoney',
	label: '优惠金额',
	width: '180',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'wipeZeroMoney',
	label: '抹零金额',
	width: '120',
	headerAlign: 'center',
	ischoose: true,
	align: 'right'
}, {
	prop: 'remark',
	label: '整单备注',
	width: '300',
	ischoose: true,
	align: 'center'
}]
